import { useState, useEffect } from "react";
import { Pagination } from "@mui/material";
import { RiLoader4Line } from "react-icons/ri";
import { useMediaQuery } from "@mui/material";

import { ScreenType } from "../../utils/breakpoints";

import CustomSort from "./Components/CustomSort";
import PageCountSelect from "./Components/PageCountSelect";
import CustomSearchInputV2 from "./Components/CustomSearchInputV2";
import CustomMenu from "../CustomMenu";



import "./style.css";


function CustomTable({
    id = "",
    className = "",
    title = "",
    description = "",
    table = {},
    store,
    actions,
    withPagination = true,
    withSearch = true,
    defaultPage = 1,
    defaultPerPage = 10,
    type = 1, // 1 = search will move to table's upper right side in mobile view,
}) {
    const screenSize = ScreenType(useMediaQuery);
    const compress = screenSize == "s2" || screenSize == "s";

    const [page, setPage] = useState(defaultPage);
    const [perPage, setPerPage] = useState(defaultPerPage);
    const [sort, setSort] = useState(null);
    const [search, setSearch] = useState();
    const [filter, setFilter] = useState();
    const [allow, setAllow] = useState(false);

    const getList = () => {

        if (allow) {
            actions?.emptyTable && actions.emptyTable();
            actions?.get && actions.get(page, perPage, { search: search, ...filter }, sort)
        }
    }

    const paginate = (e, page) => {
        setPage(page)
    }

    const sortTable = (key, order) => {
        setSort({ column: key, order: order });
    }

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    const updateFilter = (key, value) => {
        let temp = { ...filter };
        temp[key] = value?.value;
        setPage(1);
        setFilter(temp);
    }

    useEffect(() => {
        // SETUP FILTERS
        let temp = {};
        for (let x = 0; x < actions?.filters.length; x++) {
            temp[actions?.filters[x]?.key] = actions?.filters[x]?.options[0]?.value;
        }
        setFilter(temp);
    }, []);

    useEffect(() => {
        // SETUP SORT
        // {
        //     column: "bdp.date_of_last_appointment",
        //     order: "desc",
        // }

        for (let x = 0; x < table.headers.length; x++) {
            if (table.headers[x]?.default) {
                setSort({
                    column: table.headers[x]?.value,
                    order: "DESC",
                });
            }

        }
    }, [table.headers?.length]);

    useEffect(() => {
        getList();
    }, [sort, page, perPage, filter, search]);

    useEffect(() => {
        if (actions?.getDependency?.value) {
            setAllow(true);
            setFilter({ ...filter, [actions?.getDependency?.key]: actions?.getDependency?.value });
        }
    }, [actions?.getDependency?.value]);



    return (
        <div id={id} className={`custom-table ${className} ${compress ? "ct-compress" : ""}`}>
            <div className="custom-table-wrapper">
                <div className="ctw-header">
                    <div className="ctw-title">
                        <h4>{capitalizeWords(title)}</h4>
                    </div>
                    <div className="ctw-actions row">
                        {
                            actions?.filters && actions.filters.map((filter, i) => {
                                return (
                                    <div className={`ctw-action-filter caf-${i + 1} ${compress && "col-md-6"}`}>
                                        <CustomMenu key={filter?.key} label={filter?.label} items={filter?.options} onChange={(options) => {
                                            filter?.onChange && filter?.onChange(options);
                                            updateFilter(filter?.key, options);
                                        }} />
                                    </div>
                                )
                            })
                        }

                        {
                            (withSearch) && <div className={compress && "col-md-12"}>
                                <CustomSearchInputV2
                                    minimumLength={3}
                                    handleChange={(val) => {
                                        setSearch(val);
                                        // searchData();
                                    }}
                                    onclick={() => {
                                        // searchData();
                                    }}
                                />
                            </div>
                        }


                    </div>
                </div>
                <div className={`ctw-description ${compress ? "ctw-d-compress" : ""}`}>
                    <h5>Total Records: {store?.count}</h5>
                    {/* 
                    {
                        (withSearch && compress) && <CustomSearchInputV2
                            minimumLength={3}
                            handleChange={(val) => {
                                setSearch(val);
                                // searchData();
                            }}
                            onclick={() => {
                                // searchData();
                            }}
                        />
                    } */}
                </div>
                <div className="ctw-table">
                    <table>
                        <thead>
                            <tr>
                                {
                                    table.headers.map(({ title, value, align }, i) => {
                                        return (
                                            <th>
                                                <div style={{ justifyContent: align }}>
                                                    <h6>
                                                        {capitalizeWords(title)}
                                                    </h6>
                                                    {
                                                        value && <CustomSort active={(sort && sort.column == value) ? sort.order : null} Sort={(sortType) => {
                                                            sortTable(value, sortType);
                                                        }} />
                                                    }
                                                </div>
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                store?.list && store?.list.map(
                                    (item, i) => {
                                        return (
                                            table.body(
                                                item,
                                                ((page - 1) * perPage) + (i + 1),
                                            )
                                        )
                                    })
                            }

                            {
                                (store?.list === null || store?.list.length == 0) && <tr className={`pi-c-l pi-c-l-odd`}>
                                    <td className='td-status-area' colSpan={table.headers?.length}>
                                        {store?.list === null && <RiLoader4Line className="custom-loader-icon rotate" />}
                                        {store?.list !== null && <h6>No Discharged Patients Found</h6>}
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                {
                    withPagination && <div className="ctw-footer-actions">
                        <div>
                            <div className="ctw-fa-page-details">
                                <h6>Page: {page} of {(Math.ceil(store?.count / perPage) || 0)}</h6>
                            </div>
                            <PageCountSelect onChange={(val) => {
                                setPerPage(val);
                            }} />
                        </div>
                        <Pagination count={Math.ceil(store?.count / perPage)} page={page} variant="outlined" shape="rounded" onChange={paginate} />
                    </div>
                }

            </div>
        </div>
    );
}

export default CustomTable;